import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonialsIntro } from '../data/salesData';
export function TestimonialsIntro() {
  return <section className="py-16 px-4 bg-white" data-id="element-265">
      <div className="max-w-6xl mx-auto" data-id="element-266">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-267">
          {testimonialsIntro.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-surface-light rounded-lg p-6 shadow-sm" data-id="element-268">
              <div className="flex gap-0.5 mb-4" data-id="element-269">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 fill-highlight text-highlight" data-id="element-270" />)}
              </div>
              <div className="flex items-start gap-4 mb-4" data-id="element-271">
                <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-272">
                  {testimonial.initials}
                </div>
                <div data-id="element-273">
                  <p className="font-semibold text-gray-900" data-id="element-274">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-275">{testimonial.city}</p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-276">
                    {testimonial.role}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-277">"{testimonial.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}